import { Injectable } from '@angular/core';

import { TranslationLookup } from '@neutrino/core/translation';
import { NotifyService } from '@neutrino/core/notify';

@Injectable()
export class TranslationLookupService extends TranslationLookup {
    constructor(private notify: NotifyService) {
        super();
    }

    lookup(key: string): string {
        // TODO: translation?
        return key;
    }
}
